import React, { Component } from "react";
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import apiCall from "../utils/apiCall";
import { connect } from "react-redux";
import { cartInfo } from "./common/redux/actions";
import { Button } from "@mui/material";
import { Package, CheckCircle, Circle, ShoppingCart } from "lucide-react";
import "./styles/Number.css";
import { useNavigate } from "react-router-dom";

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

class FamilyBusinessPack extends Component {
  state = {
    packSize: 2,
    packs: [], // [{ category, numbers: [numberObj, ...], selected: [ids] }]
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.fetchPacks();
  }

  fetchPacks = async () => {
    this.setState({ loading: true, error: null });
    try {
      // Fetch categories
      const { result: catResult } = await apiCall(
        "REACT_APP_GET_CATEGORY",
        "POST",
        { limit: 20, skip: 0 },
        false
      );
      let categories = [];
      if (catResult && catResult.success && catResult.status) {
        categories = catResult.status;
      }
      // Fetch numbers for each category and split into packs
      let packs = [];
      for (let cat of categories) {
        const { result: numResult } = await apiCall(
          "REACT_APP_GET_NUMBERS",
          "POST",
          { categoryId: [cat.id], status: [2], limit: 100, skip: 0 },
          false
        );
        if (numResult && numResult.success && numResult.status) {
          const chunks = chunkArray(numResult.status, this.state.packSize);
          for (let chunk of chunks) {
            if (chunk.length === this.state.packSize) {
              packs.push({
                category: cat.categoryName,
                numbers: chunk,
                selected: [], // default: none selected
              });
            }
          }
        }
      }
      this.setState({ packs, loading: false, error: null });
    } catch (error) {
      this.setState({ loading: false, error: "Failed to load data." });
    }
  };

  handlePackSizeChange = (e) => {
    let value = parseInt(e.target.value);
    if (value < 2) value = 2;
    this.setState({ packSize: value }, this.fetchPacks);
  };

  handleSelectNumber = (packIdx, numberId, checked) => {
    this.setState((prevState) => {
      const packs = [...prevState.packs];
      let selected = packs[packIdx].selected;
      if (checked) {
        if (!selected.includes(numberId)) selected = [...selected, numberId];
      } else {
        if (selected.length > 1) {
          selected = selected.filter((id) => id !== numberId);
        }
      }
      packs[packIdx] = { ...packs[packIdx], selected };
      return { packs };
    });
  };

  handleSelectAll = (packIdx, checked) => {
    this.setState((prevState) => {
      const packs = [...prevState.packs];
      packs[packIdx] = {
        ...packs[packIdx],
        selected: checked ? packs[packIdx].numbers.map((n) => n.id) : [packs[packIdx].numbers[0].id],
      };
      return { packs };
    });
  };

  getTotalPrice = (pack) => {
    return pack.numbers
      .filter((n) => pack.selected.includes(n.id))
      .reduce((sum, n) => sum + parseFloat(n.discountedPrice || n.price || 0), 0);
  };

  handleBuyNowPack = async (pack) => {
    // Gather selected numbers from this pack only
    const selectedNumbers = pack.numbers.filter((n) => pack.selected.includes(n.id));
    if (selectedNumbers.length === 0) return;
    for (const num of selectedNumbers) {
      await apiCall("REACT_APP_ADD_TO_CART", "POST", { numberId: num.id });
    }
    this.props.cartInfo({ cartDetails: selectedNumbers });
    this.props.navigate("/cart");
  };

  renderPackCard(pack, idx) {
    const allSelected = pack.selected.length === pack.numbers.length && pack.numbers.length > 0;
    return (
      <div
        key={idx}
        style={{
          border: "1px solid #e0e7ef",
          borderRadius: 18,
          padding: 24,
          margin: 18,
          minWidth: 320,
          background: "white",
          boxShadow: "0 4px 24px 0 #e3e8f0",
          flex: 1,
          maxWidth: 370,
          transition: "box-shadow 0.2s",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
          <input
            type="checkbox"
            checked={allSelected}
            onChange={(e) => this.handleSelectAll(idx, e.target.checked)}
            style={{ marginRight: 10, accentColor: "#000040" }}
          />
          <span style={{ fontWeight: 700, fontSize: 18, color: "#000040" }}>
            {pack.category} Pack
          </span>
        </div>
        <div style={{ marginBottom: 10 }}>
          <div style={{ 
            maxHeight: '300px', 
            overflowY: 'auto',
            paddingRight: '8px'
          }}>
            {pack.numbers.map((num) => (
              <div
                key={num.id}
                style={{
                  border: "1px solid #d1d9e6",
                  borderRadius: 10,
                  margin: "10px 0",
                  padding: 10,
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  boxShadow: pack.selected.includes(num.id)
                    ? "0 2px 8px #e3e8f0"
                    : "none",
                  transition: "background 0.2s, box-shadow 0.2s",
                }}
              >
                <input
                  type="checkbox"
                  checked={pack.selected.includes(num.id)}
                  disabled={
                    !pack.selected.includes(num.id) && pack.selected.length >= pack.numbers.length
                  }
                  onChange={(e) => this.handleSelectNumber(idx, num.id, e.target.checked)}
                  style={{ marginRight: 10, accentColor: "#000040" }}
                />
                <div style={{ flex: 1 }}>
                  <span style={{ fontWeight: 700, fontSize: 18, color: "#000040" }}>{num.number}</span>
                  <div style={{ color: "#000040", fontSize: 15 }}>
                    Rs. {num.discountedPrice || num.price}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ marginTop: 10, fontWeight: 600, color: "#000040" }}>
          Selected : {pack.selected.length}/{pack.numbers.length}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "8px 0 0 0", justifyContent: "space-between" }}>
          <div style={{ fontSize: 20, fontWeight: 800, color: "#000040" }}>
            Rs. {this.getTotalPrice(pack)}
          </div>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{
              background: "#c60000",
              fontWeight: 700,
              color: "white",
              fontSize: 14,
              padding: "6px 18px",
              borderRadius: 6,
              boxShadow: "0 2px 8px #e3e8f0",
              letterSpacing: 1,
              minWidth: 0,
              height: 36,
              display: "flex",
              alignItems: "center",
              gap: 6,
              justifyContent: "center",
            }}
            onClick={() => this.handleBuyNowPack(pack)}
            disabled={pack.selected.length === 0}
          >
            <ShoppingCart size={18} style={{ marginRight: 4 }} /> Buy Now
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { packSize, packs, loading, error } = this.state;
    return (
      <div className="mainContent">
        <HeaderNav activeTabName="family-business-pack" />
        <div
          style={{
            padding: 32,
            background: "white",
            minHeight: "100vh",
            marginTop: 64,
          }}
        >
          <h1
            style={{
              textAlign: "center",
              fontWeight: 800,
              fontSize: 40,
              marginBottom: 32,
              letterSpacing: 1,
              color: "#000040",
              textShadow: "0 2px 8px #e3e8f0",
            }}
          >
            <Package size={36} style={{ marginRight: 10, verticalAlign: "middle", color: "#000040" }} />
            FAMILY & BUSINESS <span style={{ color: "#c60000" }}>PACK</span>
          </h1>
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <label style={{ fontWeight: 700, marginRight: 10, fontSize: 18 }}>
              Numbers per pack:
            </label>
            <input
              type="number"
              min={2}
              value={packSize}
              onChange={this.handlePackSizeChange}
              style={{
                width: 70,
                fontSize: 20,
                padding: 6,
                borderRadius: 8,
                border: "1.5px solid #000040",
                textAlign: "center",
                marginRight: 10,
              }}
            />
            <span style={{ color: "#888", fontSize: 16 }}>(minimum 2)</span>
          </div>
          {loading && <div style={{ textAlign: "center", fontSize: 20 }}>Loading...</div>}
          {error && <div style={{ color: "red", textAlign: "center", fontSize: 18 }}>{error}</div>}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 32,
            }}
          >
            {packs.map((pack, idx) => this.renderPackCard(pack, idx))}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <FamilyBusinessPack {...props} navigate={navigate} />;
}

export default connect(null, { cartInfo })(WithNavigate); 